// src/services/uploader.js
import axios from 'axios'; // 使用 axios 发送请求

/**
 * 上传文件到七牛云
 * @param {File} file 要上传的文件对象
 * @param {string} token 从你后端获取的有效七牛云上传Token
 * @param {string} [keyPrefix='product/'] 文件在七牛云存储中的路径前缀 (可选)
 * @returns {Promise<string>} 上传成功后返回文件在七牛云中的 key
 */
export const uploadToQiniu = async (file, token, keyPrefix = 'product/') => {
  if (!file || !token) {
    throw new Error('缺少文件或上传凭证');
  }

  // 1. 生成文件名 (保持唯一性)
  const timestamp = Date.now();
  const randomString = Math.random().toString(36).slice(2);
  const fileName = `${timestamp}_${randomString}_${file.name}`;
  const fileKey = `${keyPrefix}${fileName}`; // 完整的文件 key

  // 2. 准备 FormData
  const formData = new FormData();
  formData.append('token', token);
  formData.append('key', fileKey);
  formData.append('file', file); // 'file' 是七牛云接收文件的字段名

  // 3. 发送上传请求到七牛云上传地址
  //    注意：'https://upload.qiniup.com' 是华东区的上传地址，
  //    你需要根据你的七牛云存储空间所在区域选择正确的上传地址。
  //    参考：https://developer.qiniu.com/kodo/1671/region-endpoint-fq
  const uploadUrl = 'https://upload.qiniup.com'; // !! 请确认这个地址适合你的存储区域 !!

  try {
    const response = await axios.post(uploadUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      // 可选：添加上传进度处理
      // onUploadProgress: (progressEvent) => {
      //   const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      //   console.log(`上传进度: ${percentCompleted}%`);
      //   // 你可以在这里触发进度事件给调用者
      // },
    });

    // 4. 处理响应
    if (response.data && response.data.key) {
      console.log('七牛云上传成功:', response.data);
      return response.data.key; // 返回文件的 key
    } else {
      // 如果响应格式不符合预期
      throw new Error(response.data?.error || '上传失败: 无效的响应');
    }
  } catch (error) {
    console.error('七牛云上传失败:', error.response?.data || error.message);
    // 抛出更详细的错误信息
    const qiniuError = error.response?.data?.error;
    throw new Error(`图片上传失败: ${qiniuError || error.message || '请重试'}`);
  }
};